export default __webpack_public_path__ + "static/media/image04.084829d1.jpg";